/**
 * Runtime environment configuration.
 *
 * In production (Docker / Container Apps) the values come from
 * window.__ENV__, which is generated at container startup by
 * docker/generate-env-config.sh and loaded via env-config.js
 * in index.html BEFORE the app bundle.
 *
 * In local dev (`npm run dev` / `vite dev`) window.__ENV__ won't
 * exist, so we fall back to Vite's import.meta.env which reads
 * from .env files as usual.
 *
 * This is the ONLY file that should read import.meta.env.VITE_*
 * or window.__ENV__. Everything else imports from here.
 */

interface RuntimeEnv {
  API_BASE_URL: string
  API_TIMEOUT: string
  ENV: string
}

declare global {
  interface Window {
    __ENV__?: Partial<RuntimeEnv>
  }
}

const runtimeEnv = window.__ENV__ ?? {}

export const ENV = {
  /** Base URL of the backend API (no trailing slash). */
  apiBaseUrl:
    runtimeEnv.API_BASE_URL ||
    import.meta.env.VITE_API_BASE_URL ||
    'http://localhost:8000',

  /** Request timeout in milliseconds. */
  apiTimeout: Number(
    runtimeEnv.API_TIMEOUT ||
      import.meta.env.VITE_API_TIMEOUT ||
      30000,
  ),

  /** Environment name: development | staging | production. */
  environment:
    runtimeEnv.ENV ||
    import.meta.env.VITE_ENV ||
    import.meta.env.MODE ||
    'development',

  /** Vite dev server running (true only during `npm run dev`). */
  isDevelopment: import.meta.env.DEV,

  /** Production Vite build. */
  isProduction: import.meta.env.PROD,
}

export default ENV
